<div>
  @if (edit) {
    <label for="datasourceType">Datasource Type</label>
    <select id="datasourceType" [ngModel]="contact.datasource" (ngModelChange)="onModelChange($event)">
      @for (datasource of datasourceTypes; track datasource) {
        <option>{{datasource}}</option>
      }
    </select>
  }
  <ng-container #portal></ng-container>
</div>

<ng-template #context>
  @if (contextObject) {
    <div class="grid-x">
      <property-selector [object]="contextObject" [propertyPath]="contact.data" (selectedProperty)="contact.data = $event.path"></property-selector>
      <p>Selected Property: {{contact.data}}</p>
    </div>
    <ng-container [ngTemplateOutlet]="other"></ng-container>
  } @else {
    This datasource type is not available with this template!
  }
</ng-template>
<ng-template #rule>
  <label for="rule">
    Rule:
    <textarea name="rule" placeholder="Rule"
      data-transition-key="Rule"
    [(ngModel)]="contact.data"></textarea>
  </label>
  <ng-container [ngTemplateOutlet]="other"></ng-container>
</ng-template>
<ng-template #activeUser>
  <ng-container [ngTemplateOutlet]="other"></ng-container>
</ng-template>

<ng-template #other>
  <label for="saveLocation">Context Save Location</label>
  <input type="text" id="saveLocation" placeholder="Context Location" data-transition-key="saveLocation" [(ngModel)]="contact.saveLocation" />
  <label for="dataType">Additional Data Types</label>
  <select id="dataType" [ngModel]="selectedDataTypes" multiple (ngModelChange)="selectAdditionalTypes($event)">
    @for (type of additionalData; track type) {
      <option [value]="type">{{type}}</option>
    }
  </select>
</ng-template>